export const GET_CIVIL_STATE = 'GET_CIVIL_STATE';
export const LOADING_CIVIL_STATE = 'LOADING_CIVIL_STATE';